import(/* webpackMode: "eager" */ "/vercel/path0/Website/components/ui/Blog-List.tsx")